import { render, staticRenderFns } from "./MbTest.vue?vue&type=template&id=3b0d8400&scoped=true&"
import script from "./MbTest.vue?vue&type=script&lang=js&"
export * from "./MbTest.vue?vue&type=script&lang=js&"
import style0 from "./MbTest.vue?vue&type=style&index=0&id=3b0d8400&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0d8400",
  null
  
)

export default component.exports